import { GoogleCSVExporter } from '@root/utils/Export';

import DocumentEditor from './components/GoogleAdEditor';
import DocumentPreview from './components/GoogleAdPreview';
import Icon from './GoogleAd.icon';

// google ads constants
const MAX_GOOGLEAD_HEADLINE_CHARS = 30;
const MAX_GOOGLEAD_DESCRIPTION_CHARS = 90;

const getAd = (doc) => `${doc.content.headline1
} | ${
  doc.content.headline2
} | ${
  doc.content.headline3
}\n${
  doc.content.description1
}\n${
  doc.content.description2}`;

const getClipboardItem = (doc) => {
  return `Ad Titles: ${
    doc.content.headline1.replace('\n', '')
  } | ${
    doc.content.headline2.replace('\n', '')
  } | ${
    doc.content.headline3.replace('\n', '')
  } \nAd Copy: ${
    doc.content.description1.replace(/(<([^>]+)>)/ig, '')
  } ${
    doc.content.description2.replace(/(<([^>]+)>)/ig, '')
  }`;
};

const getCsvContent = (docs) => {
  const exporter = new GoogleCSVExporter();

  docs.forEach((doc) => {
    exporter.addAdvert(
      doc.content.headline1,
      doc.content.headline2,
      doc.content.headline3,
      doc.content.description1,
      doc.content.description2,
      '', // url
    );
  });

  return exporter.getString();
};

const getPdfContent = (docs) => docs.reduce((pdf, doc) => {
  const ad = getAd(doc);
  return `${pdf}${ad}\r\n\n`;
}, '');

const getTxtContent = (docs) => docs.reduce((txt, doc) => {
  const ad = getAd(doc);
  return `${txt}${ad}\r\n\n`;
}, '');

const getWordCounts = (document) => {
  return [
    {
      title: 'Headline 1',
      value: document.content.headline1 || '',
      limit: MAX_GOOGLEAD_HEADLINE_CHARS,
    },
    {
      title: 'Headline 2',
      value: document.content.headline2 || '',
      limit: MAX_GOOGLEAD_HEADLINE_CHARS,
    },
    {
      title: 'Headline 3',
      value: document.content.headline3 || '',
      limit: MAX_GOOGLEAD_HEADLINE_CHARS,
    },
  ];
};

const getWordCountSecondRow = (document) => {
  return [
    {
      title: 'Description 1',
      value: document.content.description1 || '',
      limit: MAX_GOOGLEAD_DESCRIPTION_CHARS,
    },
    {
      title: 'Description 2',
      value: document.content.description2 || '',
      limit: MAX_GOOGLEAD_DESCRIPTION_CHARS,
    },
  ];
};

export default {
  Icon,
  DocumentEditor,
  DocumentPreview,
  getWordCounts,
  getWordCountSecondRow,
  stringifyContent: (templateContent) => `Headline 1: ${templateContent.headline1}
   Headline 2: ${templateContent.headline2}
   Headline 3: ${templateContent.headline3}
   Description 1: ${templateContent.description1}
   Description 2: ${templateContent.description2}
  `,
  onMoreLikeThis: async (props, document) => {
    if (!props.canManageDocuments) {
      return null;
    }

    return props.generate({ likeId: document._id });
  },
  getTxtContent,
  getPdfContent,
  getCsvContent,
  getClipboardItem,
};
